<div *ngFor="let textTypeEntry of textTypeEntries">
    <span>
        <strong>{{ textTypeEntry.languageName }}: </strong>
    </span>
    <span>{{ textTypeEntry.text }}</span>
</div>
